import { render, staticRenderFns } from "./Agree.vue?vue&type=template&id=c3a152e8&"
import script from "./Agree.js?vue&type=script&lang=js&"
export * from "./Agree.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports